import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
//import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import "../Codes/style/tableVoucherTransfersMobile.css"
//import moment from 'moment';
import { isMobile } from 'react-device-detect';


const useStyles = makeStyles(theme => ({
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: '100%',
            height: '100%',
            margin: "auto",
            display: "block"
        },
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            height: '100%',
            margin: "auto",
            display: "block"
        },
        [theme.breakpoints.up('md')]: {
            width: '70%',
            height: '70%',
            margin: "auto",
            display: "block"
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            height: '70%',
            margin: "auto",
            display: "block"
        },
        [theme.breakpoints.up('xl')]: {
            width: '70%',
            height: '70%',
            margin: "auto",
            display: "block"
        },
    },
    logoallwidth: {
        [theme.breakpoints.up('xs')]: {
            width: '60%',
            height: '60%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('lg')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            width: '100%',
            height: '100%'
        },
    },
    fondocabecera: {
        textAlign: "center",
    },
    textocabecera: {
        [theme.breakpoints.up('xs')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            //fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('sm')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            //fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('md')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            //fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('lg')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            //fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('xl')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            //fontFamily: "RobotoCondensed-Bold",
        },
    },
    textovalor: {
        color: '#1a1919',
        fontSize: '350%',
        textAlign: "left",

        fontWeight: 'bold'
    },
    textocabeceradetalle: {
        color: '#000000',
        fontSize: '110%',
    },
    textocabeceradetalleinvisible: {
        color: '#EEEFF2',
        fontSize: '110%',
    },
    textovalorreduce: {
        color: '#1a1919',
        fontSize: '200%',
        textAlign: "left",

        fontWeight: 'bold'
    },
    textotitulodetalle: {
        color: '#1a1919',
        fontSize: '100%',
        maxWidth: '100%',

        fontWeight: 'bold'
    },
    textotitulodetallenegrita: {
        color: '#009aa8',
        fontSize: '100%',

        fontWeight: 'bold'
    },
    texttitleone: {
        color: '#0073D2',
        //fontFamily: "RobotoCondensed-Bold",
        fontSize: '80%'
    },
    texttitletwo: {
        color: '#0073D2',
        //fontFamily: "RobotoCondensed-Bold",
        fontSize: '80%'
    },
    line: {
        backgroundColor: '#009aa8',
        height: '1px',
        width: '100%'
    },
    fondotexto: {
        backgroundColor: 'white'
    },
    gridMonto: {
        backgroundColor: "#0073D2"
    },
    gridTexto: {
        backgroundColor: "#EEEFF2"
    },
    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
    }
}));

const VoucherTransfersMobile = props => {

    const classes = useStyles();

    const {
        title,
        
        monto,
        
        handleDownloadVoucher,
        handleDownloadDevice,
        resetviewtransfert,
        
        typesizegrid,
        databodyone,
        databodytwo,
        titleone,
        titletwo,
    } = props;

    return (
        <div>
            <Grid container spacing={3} className={classes.fondocabecera} alignItems="center" direction="row" justify="center">
                <Grid item xs={12} md={12}>
                    <img src={process.env.PUBLIC_URL + '/images/Logo-544x96.png'} alt="Logo" className={(typesizegrid === 6) ? classes.logo : classes.logoallwidth} />
                </Grid>
            </Grid>
            <br />
            <br />
            <Grid container spacing={3} className={classes.gridMonto} alignItems="center" direction="row" justify="center">

                <Grid item xs={6} md={6} >
                    <br />
                    <Typography component="h1" variant="h1" className={classes.textocabecera} align="center">
                        {title}
                    </Typography>
                    <br />
                </Grid>
                <Grid item xs={6} md={6}>
                    <br />
                    <Typography component="h1" variant="h1" className={classes.textocabecera} align="center">
                        $ {parseFloat(monto).toFixed(2)}
                    </Typography>
                    <br />
                </Grid>

            </Grid>
            <Grid container spacing={3} className={classes.gridMonto} alignItems="center" direction="row" justify="center">
                <Grid item xs={6} md={6} className={classes.gridTexto}>
                    <Typography component="h1" variant="h1" className={classes.textocabeceradetalleinvisible} align="center">
                        {"Valor cancelado"}
                    </Typography>
                </Grid>

                <Grid item xs={6} md={6} className={classes.gridTexto}>
                    <Typography component="h1" variant="h1" className={classes.textocabeceradetalle} align="center">
                        {"Valor cancelado"}
                    </Typography>
                </Grid>

            </Grid>
            <br />


            <Grid container spacing={3} alignItems="center" direction="row" justify="center">
                <Grid item xs={12} md={12} ></Grid>
                <Grid item xs={10} md={10} className={classes.fondotexto}>
                    {
                        (titleone.length > 0) &&
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitleone}>{titleone}</b>
                        </Typography>
                    }
                    {
                        databodyone.map(row => (
                            <div key={row.order}>
                                <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                                    <b className={classes.textotitulodetallenegrita}>{row.title}:</b> {row.value}
                                </Typography>
                                <br />
                            </div>
                        ))
                    }
                    {(databodytwo.length > 0) && <br />}
                    {
                        (titletwo.length > 0) &&
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitletwo}>{titletwo}</b>
                        </Typography>
                    }
                    {
                        databodytwo.map(row => (
                            <div key={row.order}>
                                <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                                    <b className={classes.textotitulodetallenegrita}>{row.title}:</b> {row.value}
                                </Typography>
                                <br />
                            </div>

                        ))
                    }

                </Grid>
                <br />
                {/* <Grid item xs={6} md={6} sm = {6}>
                            <Button
                                fullWidth
                                onClick={ onActionAfter }
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon= {<AddIcon />}
                                className={classes.submit}
                            > { titlebuttonnew }</Button>
                        </Grid> */}

                {(!isMobile) &&

                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={handleDownloadVoucher}
                                variant="contained"
                                className={classes.submit}
                            > Imprimir</Button></Grid>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={resetviewtransfert}
                                variant="contained"
                                className={classes.submit}
                            > Nueva Transferencia</Button>
                        </Grid> </Grid>
                }
                {(isMobile) &&
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6} >
                            <Button
                                size="small"
                                fullWidth
                                onClick={handleDownloadDevice}
                                variant="contained"
                                className={classes.submit}
                            > Compartir</Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={resetviewtransfert}
                                variant="contained"
                                className={classes.submit}
                            > Nueva Transferencia</Button>
                        </Grid>
                    </Grid>
                }



                {/* {(!isMobile) &&

                    <Grid item xs={6} md={6} sm={6}>
                        <Button

                            fullWidth
                            onClick={handleDownloadVoucher}
                            variant="contained"
                            color="primary"
                            //startIcon = {<CloudDownloadIcon />}
                            className={classes.submit}
                        > Descargar Comprobante</Button>
                    </Grid>
                }
                {(isMobile) &&

                    <Grid item xs={6} md={6} sm={6}>
                        <Button

                            fullWidth
                            onClick={handleDownloadDevice}
                            variant="contained"
                            color="primary"
                            //startIcon = {<CloudDownloadIcon />}
                            className={classes.submit}
                        > Compartir Comprobante</Button>
                    </Grid>
                }

                <Grid item xs={6} md={6} sm={6}>
                    <Button

                        fullWidth
                        onClick={handleResetPayment}
                        variant="contained"
                        color="primary"
                        //startIcon = {<CloudDownloadIcon />}
                        className={classes.submit}
                    > Nueva Transferencia</Button>
                </Grid> */}
            </Grid>






            {/* <Grid container spacing={3} alignItems="center" direction="row" justify="center">
                <Grid item xs={12} md={12}>
                    <Grid item xs={12} md={12}>
                        <img src={process.env.PUBLIC_URL + '/images/Logo-544x96.png'} alt="Logo" className= { (typesizegrid === 6) ? classes.logo : classes.logoallwidth} />
                    </Grid>
                    <br /><br />
                    <Grid item xs={12} md={12}>
                        <Typography component="h1" variant="h1" className={classes.textocabecera} align="center">
                            {title}
                        </Typography>
                    </Grid>

                </Grid>

            </Grid>
            <br /><br />
            <Grid container spacing={3} alignItems="center" direction="row" justify="center">

                <Grid item xs={12} md={12}>
                    <table class="table1">
                        <thead>
                            <tr>
                                <th></th>
                                <th scope="col" abbr="Starter">Ordenante</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">Nombre</th>
                                <td>{nombreCliente}</td>
                            </tr>
                            <tr>
                                <th scope="row"># Cuenta</th>
                                <td>{numeroCuentaOrigen}</td>
                            </tr>
                            <tr>
                                <th scope="row">Tipo de cuenta</th>
                                <td>{tipoCuentaOrigen}</td>
                            </tr>
                            <tr>
                                <th scope="row">Institución Financiera</th>
                                <td>COOPERATIVA GAÑANSOL</td>
                            </tr>
                        </tbody>
                    </table>

                </Grid>

                <Grid item xs={12} md={12}>
                    <table class="table1">
                        <thead>
                            <tr>
                                <th></th>
                                <th scope="col" abbr="Starter">Beneficiario</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">Nombre</th>
                                <td>{nombreBeneficiario}</td>
                            </tr>
                            <tr>
                                <th scope="row"># Cuenta</th>
                                <td>{numeroCuentaDestino}</td>
                            </tr>
                            <tr>
                                <th scope="row">Tipo de cuenta</th>
                                <td>{tipoCuentaDestino}</td>
                            </tr>
                            <tr>
                                <th scope="row">Institución Financiera</th>
                                <td>{institucion}</td>
                            </tr>
                        </tbody>
                    </table>

                </Grid>

                <Grid item xs={12} md={12}>
                    <table class="table1">
                        <tbody>
                            <tr>
                                <th scope="row">Monto</th>
                                <td>$ {monto}</td>
                            </tr>
                            <tr>
                                <th scope="row">Comisión</th>
                                <td>$ {comision}</td>
                            </tr>
                            <tr>
                                <th scope="row">Concepto</th>
                                <td>{concepto}</td>
                            </tr>
                            <tr>
                                <th scope="row">Fecha</th>
                                <td>{moment(fecha).format("YYYY-MM-DD")}</td>
                            </tr>
                            <tr>
                                <th scope="row">Dispositivo</th>
                                <td>{dispositivo}</td>
                            </tr>
                        </tbody>
                    </table>

                </Grid>

                <br />
                <br />

                {(!isMobile) &&

                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={handleDownloadVoucher}
                                variant="contained"
                                className={classes.submit}
                            > Imprimir</Button></Grid>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={resetviewtransfert}
                                variant="contained"
                                className={classes.submit}
                            > Nueva Transferencia</Button>
                        </Grid> </Grid>
                }
                {(isMobile) &&
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6} >
                            <Button
                                size="small"
                                fullWidth
                                onClick={handleDownloadDevice}
                                variant="contained"
                                className={classes.submit}
                            > Compartir</Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={resetviewtransfert}
                                variant="contained"
                                className={classes.submit}
                            > Nueva Transferencia</Button>
                        </Grid>
                    </Grid>
                }
            </Grid> */}

        </div>
    );
}



export default VoucherTransfersMobile;